import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StackedLineChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stacked_line_chart"}/>
}
